module.exports = __webpack_public_path__ + "img/aniversarios.35f8d698.jpeg";